import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { UserTabPageComponent } from './user-tab-page.component';

const routes: Routes = [
  // { path: 'user-tabssss',data:{name:"User-Tab",isTab:false}, component: UserTabPageComponent },
  {
    path: 'user-tab',
    data: { name: 'User-Tab', isTab: false },
    component: UserTabPageComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class UserTabPageRoutingModule {}

// { path: 'user-tab',data:{name:"User-Tab",isTab:false}
